/**
* @name: left-menu-first
* @author: weiyong
* @date: 2023-05-14 17:48
* @description：left-menu-first
* @update: 2023-05-14 17:48
*/
<template>
  <div class="enter-done expandMenu h100b"
       :class="[prefixCls,menuProps.showMenu?'open-menu':'close-menu']">
    <div class="hot-title-bar">{{t('热门应用与界面推荐')}}</div>

    <div class="menu-tabs-bar">
      <a-tabs v-model:activeKey="activeKey" :size="size">
        <a-tab-pane key="commonMenu" tab="应用菜单"></a-tab-pane>
        <a-tab-pane key="loverMenu" tab="收藏菜单"></a-tab-pane>
      </a-tabs>
    </div>
    <template v-if="activeKey==='commonMenu'">
      <right-app-menu-list/>
    </template>
    <template v-else>
      <collection-menu-list/>
    </template>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "left-menu-first",
});
</script>

<script lang="ts" setup>
import CollectionMenuList from "@/layouts/layoutFrame/military/components/collection-menu-list.vue";
import RightAppMenuList from "@/layouts/layoutFrame/military/components/right-app-menu-list.vue";
import {Button as aButton,RadioGroup as aRadioGroup,Tabs as aTabs,TabPane as aTabPane} from 'ant-design-vue'
import {useDesign} from "@/hooks/web/useDesign";
import {useRouter} from "vue-router";
import {useMenuHooks} from "@/layouts/layoutFrame/hooks/useMenuHooks";
import {useMenuStore} from "@/layouts/layoutFrame/military/viewStore/menuStore";
import {useI18n} from "@/hooks/web/useI18n";

const activeKey=ref('commonMenu');
const size=ref('small');
const {prefixCls} = useDesign('left-menu-first');

const router = useRouter();

const { t } = useI18n();
const {
  menusRef,
  genAppMenus,
  pMenuItemClick
} = useMenuHooks(router,t);

const menuStore = useMenuStore();
const {
  menuProps
}:any = storeToRefs(menuStore)

/**
 * 选择的第一层菜单
 */
const selActiveOneMenu=function (item){
  unref(menuProps).activeMenuKey=item.id;
}
genAppMenus(false,(menusAll)=>{
  unref(menuProps).menusAll=menusAll;
});
</script>

<style type="text/css" lang="less">
@prefix-cls: ~'@{namespace}-left-menu-first';

.@{prefix-cls} {

  .menu-tabs-bar{
    .ant-tabs-top > .ant-tabs-nav{
      margin-bottom: 4px;
      padding-left: 12px;
    }
  }
  .hot-title-bar {
    height: calc(var(--base-bar-height,30px) + 10px);
    line-height: calc(var(--base-bar-height,30px) + 10px);
    border-top: 1px solid var(--cb-color-border-tertiary,#ebebeb);
    border-bottom: 1px solid var(--cb-color-border-tertiary,#ebebeb);

    display: block;
    border-width: initial;
    border-style: none;
    border-image: initial;
    border-radius: 0px;
    width: 100%;
    max-width: 100%;
    cursor: default;
    vertical-align: middle;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: var(--cb-color-button-menu-text-active,#666);
    background-color: var(--cb-color-button-menu-bg-active,rgba(0,46,70,0.04314));
    border-color: var(--cb-color-button-menu-border-active,transparent);
    padding: 0px 12px;
    font-size: 12px;
  }

  .menu-btn {
    text-align: left;
    line-height: var(--menu-main-bar-height,38px);
    padding-left: 18px;
    cursor:pointer;
    color:#666;
    display: flex;
    align-items: center;

    .icon-span{
      display: inline-block;
      padding-right: 8px;
    }

    &:hover{
      color:var(--primary-color,#0a6eff);
      z-index: 100;
    }
    &.active-menu{
    }
  }
}
</style>
